import {http} from '@/http/index.js';

async function like(postId) {
  return http
    .post(`/posts/${postId}/like`)
    .then((response) => response.data.data);
}

export {like};
